"use client";

import React from "react";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { HorizontalContainer } from "@/components/layout/containers/HorizontalContainer";
import { VerticalContainer } from "@/components/layout/containers/VerticalContainer";

export default function MapLoader() {
  const t = useTranslations();

  return (
    <HorizontalContainer className="h-full w-full justify-center bg-gray-50/50">
      <VerticalContainer className="relative items-center justify-center">
        <motion.div
          className="relative h-24 w-24"
          initial="initial"
          animate="animate"
        >
          {/* Map Base */}
          <motion.svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-full w-full text-gray-300"
            variants={{
              initial: { scale: 0.9, opacity: 0 },
              animate: {
                scale: 1,
                opacity: 1,
                transition: { duration: 0.5 },
              },
            }}
          >
            <path
              d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </motion.svg>

          {/* Bouncing Pin */}
          <motion.div
            className="absolute left-1/2 top-0 -ml-6"
            variants={{
              initial: { y: -20, opacity: 0 },
              animate: {
                y: [0, -10, 0],
                opacity: 1,
                transition: {
                  y: {
                    duration: 1,
                    repeat: Infinity,
                    ease: "easeInOut",
                  },
                  opacity: { duration: 0.3 },
                },
              },
            }}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current text-primary"
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
          </motion.div>
        </motion.div>

        <motion.p
          className="mt-4 text-sm font-medium text-gray-500"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          {t("general.loading")}
        </motion.p>
      </VerticalContainer>
    </HorizontalContainer>
  );
}
